export default {
  validationMessages: {
    note_play_to_early: 'Jouée trop tôt',
    note_play_to_late: 'Jouée trop tard',
    note_missed: 'Note manquée',
    wrong_note: 'Fausse note',
    note_cut_to_early: 'Coupée trop tôt',
    note_cut_to_late: 'Coupée trop tard'
  }
};